import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { EtiquetadoContextService } from "../../context/etiquetado-context.service";
import { EtiquetadoService } from "../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-mantenimiento-designaciones',
    templateUrl: './mantenimiento-designaciones.component.html'
})
export class MantenimientoDesignacionesComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    private _filtersDropDown;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;
    public dropdownInfo: number;
    public blockchainInfo: number;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public toCloseSpinner = 0;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public deleteModal = false;
    public newEditModal = false;
    public newModal = false;
    public editModal = false;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public disabledProvincias: Subject<boolean> = new Subject();
    public disabledMunicipios: Subject<boolean> = new Subject();
    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();
    public disabledCampanyas: Subject<boolean> = new Subject();
    public disabledMarcas: Subject<boolean> = new Subject();

    public designaciones;
    public totalesDesignaciones;
    public provincias;
    public municipios;
    public almacenes;
    public designacionId;
    public denominaciones;
    public etiquetadores;
    public campanyas;
    public marcas;

    public refreshCheckboxPrueba = false;
    public refreshCheckboxFinalizada = false;

    public orderBy: string;
    public indexOrder = 11;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _etiquetadoContext: EtiquetadoContextService,
        private readonly _dataProvider: DataProvider,
        private readonly utilsService: UtilsService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            campanya: [{ value: '', disabled: true }],
            fechaInicio: [''],
            fechaFin: [''],
            etiquetador: [{ value: '', disabled: true }],
            almacen: [{ value: '', disabled: true }],
            denominacion: [{ value: '', disabled: true }],
            pais: [''],
            provincia: [{ value: '', disabled: true }],
            municipio: [{ value: '', disabled: true }],
            finca: [''],
            marca: [{ value: '', disabled: true }],
            productor: [''],
            fincaDePrueba: [''],
            finalizada: ['']
        });

        this._etiquetadoContext.mantenimientoDesignacionesFilters = null;

        this.indexOrder = this.role === 'Administrador' || this.claims.includes('D_DSG_AforoVisible') ? 12 : 11;

        this.getDesignacionesYTotales();

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this._filtersDropDown = {
                    paisId: pais.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getProvinciasByPaisId(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.provincias = resp.lista;
                        if (this.provincias.length === 1) {
                            this.filtersForm.get('provincia').patchValue(this.provincias[0]);
                            this.filtersForm.get('provincia').disable();
                            this.disabledProvincias.next(true);
                        } else {
                            this.filtersForm.get('provincia').enable();
                            this.disabledProvincias.next(false);
                        }
                    }
                });
                this.toCloseSpinner += 1;
                this._etiquetadoService.getDenominaciones(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        if (this.denominaciones.length === 1) {
                            this.filtersForm.get('denominacion').patchValue(this.denominaciones[0]);
                            this.filtersForm.get('denominacion').disable();
                            this.disabledDenominaciones.next(true);
                        } else {
                            this.filtersForm.get('denominacion').enable();
                            this.disabledDenominaciones.next(false);
                        }
                    }
                });
            } else {
                this.provincias = null;
                this.denominaciones = null;
                this.municipios = null;
                this.almacenes = null;
                this.disabledProvincias.next(true);
                this.disabledDenominaciones.next(true);
                this.disabledMunicipios.next(true);
                this.disabledAlmacenes.next(true);
                this.filtersForm.get('provincia').reset();
                this.filtersForm.get('denominacion').reset();
                this.filtersForm.get('municipio').reset();
                this.filtersForm.get('almacen').reset();
            }
        });

        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
                this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
                this.filtersForm.get('pais').disable();
            }
        }

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this._filtersDropDown = {
                    paisId: this.filtersForm.get('pais').value.id,
                    denominacionId: denominacion.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getEtiquetadores(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.etiquetadores = resp.lista;
                        if (this.etiquetadores.length === 1) {
                            this.filtersForm.get('etiquetador').patchValue(this.etiquetadores[0]);
                            this.filtersForm.get('etiquetador').disable({ onlySelf: true, emitEvent: false });
                        } else {
                            this.filtersForm.get('etiquetador').enable({ onlySelf: true, emitEvent: false });
                            this.disabledEtiquetadores.next(false);
                        }
                    }
                });

                this.toCloseSpinner += 1;
                this._etiquetadoService.getMarcas(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.marcas = resp.lista;
                        this.marcas.unshift({ id: -1, des: this._translate.instant('global.sinMarca') });
                        this.filtersForm.get('marca').enable();
                        this.disabledMarcas.next(false);
                    }
                });

                let _filters = {
                    denominacionId: denominacion.id,
                    paisId: this.filtersForm.get('pais').value.id,
                    volcadoHistorico: false
                };
                this.toCloseSpinner += 1;
                this._etiquetadoService.getCampanyas(_filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.campanyas = resp.lista;
                        this.campanyas.forEach(campanya => {
                            campanya.des = campanya.anyo.toString();
                        });
                        this.filtersForm.get('campanya').patchValue(this.campanyas[0]);
                        this.filtersForm.get('campanya').enable();
                        this.disabledCampanyas.next(false);
                    }
                });
            } else {
                this.etiquetadores = null;
                this.campanyas = null;
                this.almacenes = null;
                this.marcas = null;
                this.disabledEtiquetadores.next(true);
                this.disabledCampanyas.next(true);
                this.disabledAlmacenes.next(true);
                this.disabledMarcas.next(true);
                this.filtersForm.get('etiquetador').reset();
                this.filtersForm.get('campanya').reset();
                this.filtersForm.get('almacen').reset();
                this.filtersForm.get('marca').reset();
            }
        });

        this.filtersForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                this._filtersDropDown = {
                    etiquetadorId: etiquetador.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getAlmacenesByEtiquetadorId(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.almacenes = resp.lista;
                        this.filtersForm.get('campanya').enable();
                        this.disabledAlmacenes.next(false);
                    }
                });
            } else {
                this.almacenes = null;
                this.disabledAlmacenes.next(true);
                this.filtersForm.get('almacen').reset();
            }
        });

        this.filtersForm.get('provincia').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this._filtersDropDown = {
                    paisId: this.filtersForm.get('pais').value.id,
                    provinciaId: provincia.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getMunicipiosByProvinciaId(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.municipios = resp.lista;
                        this.disabledMunicipios.next(false);
                    }
                });
            } else {
                this.municipios = null;
                this.almacenes = null;
                this.disabledMunicipios.next(true);
                this.disabledAlmacenes.next(true);
                this.filtersForm.get('municipio').reset();
                this.filtersForm.get('almacen').reset();
            }
        });

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public pageChange(page) {
        this.dropdownSection = -1;
        this.dropdownInfo = -1
        this._etiquetadoContext.mantenimientoDesignacionesFilters.numPagina = this.currentPage = page - 1;
        this.getDesignacionesYTotales();
    }

    public itemsPerPageChange(items) {
        this.dropdownSection = -1;
        this.dropdownInfo = -1
        this._etiquetadoContext.mantenimientoDesignacionesFilters.numPagina = this.currentPage = 0;
        this._etiquetadoContext.mantenimientoDesignacionesFilters.tamPagina = this.itemsPerPage = items;
        this.getDesignacionesYTotales();
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').errors.includes('Invalid date')) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (
            this.filtersForm.get('campanya').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value ||
            (this.filtersForm.get('etiquetador').value && this.filtersForm.get('etiquetador').enabled) ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled) ||
            this.filtersForm.get('almacen').value ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('provincia').value ||
            this.filtersForm.get('municipio').value ||
            this.filtersForm.get('finca').value ||
            this.filtersForm.get('marca').value ||
            this.filtersForm.get('productor').value ||
            !this.filtersForm.get('fincaDePrueba').pristine ||
            !this.filtersForm.get('finalizada').pristine
        ) ? true : false;
    }

    public resetForm() {
        if(this.filtersForm.get('pais').disabled){
          this.filtersForm.reset({
            pais: this.filtersForm.get('pais').value
          });
        } else {
          this.filtersForm.controls['pais'].reset();
          this.filtersForm.controls['productor'].reset();
          this.filtersForm.controls['finca'].reset();
          this.filtersForm.controls['fechaInicio'].reset();
          this.filtersForm.controls['fechaFin'].reset();
          this.filtersForm.controls['fincaDePrueba'].reset();
          this.filtersForm.controls['finalizada'].reset();
        }
        this.refreshCheckboxPrueba = true;
        this.refreshCheckboxFinalizada = true;
    }

    public pristineCheckbox(idForm: string, pristine: boolean) {
        const form = this.filtersForm.get(idForm);
        pristine ? form.markAsPristine() : form.markAsDirty();
    }

    public filtrar() {
        this.validDates();
        
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    public applyFilters() {
        this.currentPage = 0;
        this._etiquetadoContext.mantenimientoDesignacionesFilters = {
            paisId: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : '',
            campanyaId: this.filtersForm.get('campanya').value ? this.filtersForm.get('campanya').value.id : '',
            fechaInicioDesignacion: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFinDesignacion: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : '',
            denominacionId: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : '',
            provinciaId: this.filtersForm.get('provincia').value ? this.filtersForm.get('provincia').value.id : '',
            almacenId: this.filtersForm.get('almacen').value ? this.filtersForm.get('almacen').value.id : '',
            municipioId: this.filtersForm.get('municipio').value ? this.filtersForm.get('municipio').value.id : '',
            marcaId: this.filtersForm.get('marca').value ? this.filtersForm.get('marca').value.id : '',
            desFinca: this.filtersForm.get('finca').value ? this.filtersForm.get('finca').value : '',
            desProductor: this.filtersForm.get('productor').value ? this.filtersForm.get('productor').value : '',
            fincaDePrueba: this.filtersForm.get('fincaDePrueba').value ? this.filtersForm.get('fincaDePrueba').value : null,
            finalizada: this.filtersForm.get('finalizada').value ? this.filtersForm.get('finalizada').value : null,
            cargaRegistroEnUso: true,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getDesignacionesYTotales();
    }

    public getDesignacionesYTotales() {
        if (this._etiquetadoContext.mantenimientoDesignacionesFilters) {
            this._filters = this._etiquetadoContext.mantenimientoDesignacionesFilters;
        } else {
            this.applyFilters();
        }

        this.getDesignaciones();
        this.getTotalesDesignaciones();
    }

    public getDesignaciones() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._filters.cargaRegBlockchainDesignacion = true;
        this._etiquetadoService.getDesignaciones(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.designaciones = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public getTotalesDesignaciones() {
        //this._spinnerService.showSpinner();
        //this.toCloseSpinner += 1;
        this.totalesDesignaciones = undefined;
        this._etiquetadoService.getTotalesDesignaciones(this._filters).toPromise().finally(() => {
            //this.checkCloseSpinner();
        }).then((resp) => {
            this.totalesDesignaciones = resp;
        });
    }

    public create() {
        this.designacionId = null;
        this.newModal = true;
    }

    public update(designacion) {
        this.designacionId = designacion.id;
        this.editModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.deleteDesignacion(this.designacionId).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.getDesignacionesYTotales();
        });
    }

    public askDelete(designacion) {
        this.designacionId = designacion.id;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
        this.editModal = false;
    }

    public refresh(value) {
        this.newEditModal = false;
        this.newModal = false;
        this.editModal = false;
        if (value) {
            this.getDesignacionesYTotales();
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('req') || mensaje.includes('ApiErrors') || mensaje.includes('error')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showAlmacenes(i) {
        this.pestanaActiva[i] = 1;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public getIcon(prop: string) {
        let iconClass = 'fa fa-sort';
        if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
            iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
        }
        return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
        if (this.designaciones && this.designaciones.length > 0) {
            if (this._etiquetadoContext.mantenimientoDesignacionesFilters) {
                this._filters = this._etiquetadoContext.mantenimientoDesignacionesFilters;
            }
        }

        if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
                {
                    orderProperty: columnFilter,
                    orderByDescending: false
                }
            ];
        } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
                {
                    orderProperty: columnFilter,
                    orderByDescending: true
                }
            ];
        }

        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._etiquetadoService.getDesignaciones(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.designaciones = resp.lista;
        });
        this.getTotalesDesignaciones();

    }

    private downloadPdf() {
        this._etiquetadoService.getDesignacionesPdfOrExcel(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:application/pdf;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
    }

    private downloadCsv() {
        this._etiquetadoService.getDesignacionesCsv(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.file' });
        });
    }

    public exportPdfOrCsv(format: string) {
        if (this.designaciones && this.designaciones.length > 0) {

            if (this._etiquetadoContext.mantenimientoDesignacionesFilters) {
                this._filters = this._etiquetadoContext.mantenimientoDesignacionesFilters;
                this._filters.tamPagina = 0;
                this._filters.tipoArchivo = format === 'pdf' ? 'Pdf' : 'Csv';
            }

            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;

            if (format !== 'csv') {
                this.downloadPdf();
            } else {
                this.downloadCsv();
            }
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
        }
    }

    public showDetails(i: number) {
        this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
        this.blockchainInfo = this.blockchainInfo === i ? -1 : i;
        if (window.innerWidth <= 1199 && (this.dropdownInfo !== -1 || this.blockchainInfo !== -1)) {
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._etiquetadoService.getDocHelp('Labeling_Designations.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    public trackByDesignacionId(index: number, designacion: { id: number }): number {
        return designacion.id;
    }
}


